export const MEMBERS = [
  {
    username: 'aniket_raj',
    firstName: 'Aniket',
    lastName: 'Raj',
    title: 'Chief of Staff',
    image: 'aniket.jpg',
    links: {
      website: 'https://aniketraj.me',
      twitter: 'https://twitter.com/AniketRaj314',
      email: 'aniket@devfolio.co',
    },
  },
  {
    username: 'prathamvaidya',
    firstName: 'Pratham',
    lastName: 'Vaidya',
    title: 'Engineering',
    image: 'pratham.jpg',
    links: {
      github: 'https://github.com/prathamVaidya',
      twitter: 'https://x.com/meetPratham',
      website: 'https://prathamvaidya.in',
    },
  },
  {
    username: 'denver',
    firstName: 'Denver',
    lastName: "D'souza",
    title: 'CEO',
    image: 'denver.jpg',
    links: {
      linkedin: 'https://in.linkedin.com/in/denverjude',
      twitter: 'https://twitter.com/denverjude',
      email: 'denver@devfolio.co',
    },
  },
  {
    username: '',
    firstName: 'Jhumri',
    title: 'Meow',
    image: 'jhumri.jpg',
    links: {
      website: 'https://devfolio.co/cat_gif',
      github: 'https://devfolio.co/cat_gif',
      twitter: 'https://devfolio.co/cat_gif',
    },
  },
  {
    username: 'swarnimw',
    firstName: 'Swarnim',
    lastName: 'Walavalkar',
    title: 'Engineering',
    image: 'swarnim.jpg',
    links: {
      github: 'https://github.com/SwarnimWalavalkar',
      website: 'https://swarnimwalavalkar.com',
      email: 'swarnim@devfolio.co',
    },
  },
  {
    username: 'veesesh',
    firstName: 'Veesesh',
    title: 'Support',
    image: 'vee.jpg',
    links: {
      twitter: 'https://x.com/vee19twt',
      website: 'https://www.veesesh.tech',
      email: 'vee@devfolio.co',
    },
  },
  {
    username: 'Ayussssh',
    firstName: 'Ayussh',
    lastName: 'Khurana',
    title: 'Marketing',
    image: 'ayussh.jpg',
    links: {
      twitter: 'https://x.com/ayussheth',
      website: 'https://ayussh.xyz/',
      email: 'ayussh@devfolio.co',
    },
  },
  {
    username: 'Nitropuma',
    firstName: 'Nirupama',
    lastName: 'Singh',
    title: 'Community',
    image: 'nirupama.jpg',
    links: {
      twitter: 'https://x.com/nitropumaa',
      linkedin: 'https://www.linkedin.com/in/nirupamasingh0102/',
      email: 'nirupama@devfolio.co',
    },
  },
  {
    username: 'sushantmishra',
    firstName: 'Sushant',
    lastName: 'Mishra',
    title: 'Engineering',
    image: 'sushant.jpg',
    links: {
      website: 'https://sushant.tech',
      twitter: 'https://x.com/sushantstwt',
      github: 'https://github.com/Sushants-Git',
    },
  },
  {
    username: 'whyash5114',
    firstName: 'Yash',
    lastName: 'Kolekar',
    title: 'Engineering',
    image: 'yash.jpg',
    links: {
      website: 'https://www.whyash5114.com',
      github: 'https://github.com/WhyAsh5114',
      linkedin: 'https://www.linkedin.com/in/whyash5114/',
    },
  },
];

export const ADVISORS = [
  {
    firstName: 'Akash',
    lastName: 'Nimare',
    title: 'Product',
    image: 'akash.jpg',
    links: {
      website: 'https://akashnimare.in',
      github: 'https://github.com/akashnimare',
      email: 'akash.nimare@devfolio.co',
    },
  },
  {
    firstName: 'Nishant',
    lastName: 'Verma',
    title: 'Design',
    image: 'nishant.jpg',
    links: {
      website: 'https://nashvail.me',
      twitter: 'https://twitter.com/nashvail',
      email: 'nishant.verma@devfolio.co',
    },
  },
  {
    firstName: 'Utkarsh',
    lastName: 'Verma',
    title: 'Engineering',
    image: 'utkarsh.jpg',
    links: {
      github: 'https://www.github.com/utkarsh-var',
      twitter: 'https://twitter.com/utkarsh_var',
      email: 'utkarsh.verma@devfolio.co',
    },
  },
];

export const IN_MEMORY_OF = {
  firstName: 'Shakti',
  lastName: 'Goap',
  title: 'Founder',
  image: 'shakti.jpg',
  links: {
    heart: 'https://devfolio.co/blog/remembering-shakti/',
  },
};
